import Col from "../element/col";
import Row from "../element/row";
import Icon from "../element/icon";
import { useNavigate } from "react-router-dom";

export default function CommonTitle(props) {
  const { className, subtitle, title, shopAll } = props;

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/shop/all");
  };

  return (
    <Row className={`common-title ${className ?? ""}`}>
      <Col>
        <p>{subtitle}</p>
        <h2>{title}</h2>
      </Col>
      {shopAll && (
        <Row
          className="h-flex gap-3 pe-4 pb-2 pointer"
          onClick={() => handleNavigate()}
        >
          <h6>Shop All</h6>
          <Icon icon="mynaui:arrow-long-right" />
        </Row>
      )}
    </Row>
  );
}
